import { reloadDatatable } from "../common/datatables";

import http from "../../services/httpService";
import { error, isEmpty } from "../common/global";
import { openSnackbar, snackbarModel } from "../common/snackbar";


const props = {
    productBundleCollectionManagementDatatableMarker: '.marker-product-management-edit-product-bundle-collections',
    productManagementDatatableClass: '.product-collection-table',
    searchterm_selector: '#SearchField',
    productstatus_selector: 'input[name=productstatus]'
};

export function initDtAdminProductBundleCollectionManagement() {

    if ($(props.productBundleCollectionManagementDatatableMarker).length) {

        $('.variant-collection-wrapper').each(function (i, obj) {

            var tableEntity = $(this).find(props.productManagementDatatableClass);

            var tableId = tableEntity.attr('id');

            dtAdminProductBundleCollectionManagement(initProductBundleCollectionManagementDatatableEvents(tableId), tableId);
        });
    }
}


export function reloadProductBundleCollectionDatatable(tableId) {
    //PURPOSE: reloads user management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable('#' + tableId, initProductBundleCollectionManagementDatatableEvents(tableId), true);
};

function initProductBundleCollectionManagementDatatableEvents(table_id) {

    var tableIdSelector = '#' + table_id;

    //PURPOSE: sets up the full row click select for the user search dt
    $(tableIdSelector).off('click').on('click', 'tbody td:not(".display-index")', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var productId = $(event.currentTarget).parent('tr').data('id');

        window.open('/administration/productmanagement/edit/' + productId, "_blank");

    });

    setTimeout(function () {
        $(tableIdSelector + ' .move-item-up').off('click').on('click', function (event) {

            manageDisplayIndexChangeRequestWorker($(this), "UP", table_id);
        });

        $(tableIdSelector + ' .move-item-down').off('click').on('click', function (event) {

            manageDisplayIndexChangeRequestWorker($(this), "DOWN", table_id);
        });

        $(tableIdSelector + ' .delete-collection-item').off('click').on('click', function (event) {

            deleteProductCollectionItem($(this), table_id);
        });

        $(tableIdSelector + ' .set-item-as-default').off('click').on('click', function (event) {

            setProductCollectionItemAsDefault($(this), table_id);
        });

    }, 1000);

    if (!isEmpty($(tableIdSelector).data('last-index-changed'))) {

        var lastIndexChangedId = $(tableIdSelector).data('last-index-changed');

        //last event was an index change on a row. find the row, apply a class to visually indicate change
        var targetTr = $(tableIdSelector + " tr[data-id=" + lastIndexChangedId + "]");

        if (!isEmpty(targetTr)) {

            targetTr.addClass('bg-light-green');

            setTimeout(function () {

                targetTr.removeClass('bg-light-green');

                $(tableIdSelector).data('last-index-changed', null)

            }, 250);
        }
    }
}

function dtAdminProductBundleCollectionManagement(onloadCallback, table_id) {

    var table_id_selector = '#' + table_id;

    if ($(table_id_selector).length === 0) return false;

    $(table_id_selector).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/productbundlecollection/productbundlecollectionsearch',
            data: function (d) {

                var collection_wrapper = $(table_id_selector).closest('.variant-collection-wrapper');

                d.collectionId = collection_wrapper.data('variant-collection-id');

            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'displayIndex', name: 'Index' },            
            { data: 'code', name: 'SKU' },
            { data: 'title', name: 'Title' },
            { data: 'productStatus', name: 'Status' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    var content = '';

                    if (o.isDefault === false) {

                        content = '<div class="text-center"><div class="set-item-as-default mdc-button mdc-button--raised bg-green text-white mr-2" data-id="' + o.id + '">Make Default</div></div>';
                    } else {

                        content = '<div class="bg-white text-green text-center" data-id="' + o.id + '"><strong>CURRENT DEFAULT</strong></div>';
                    }

                    return content;
                },
                class: 'display-index no-padding-x no-padding-y'
            },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    var upArrowHtml = '<i class="material-icons text-green text-size-rem-30 move-item-up" title="" data-id="' + o.id + '">expand_less</i>';
                    var downArrowHtml = '<i class="material-icons text-green text-size-rem-30 move-item-down" title="" data-id="' + o.id + '">expand_more</i>';

                    return upArrowHtml + downArrowHtml;
                },
                class: 'text-align-center display-index no-padding-x no-padding-y'
            },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="delete-collection-item mdc-button mdc-button--raised bg-red text-white min-width-100 hidden-xs mr-2" data-id="' + o.id + '">Delete</div>'
                },
                class: 'text-align-right display-index no-padding-x no-padding-y'
            }
        ],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }
    });
}

async function manageDisplayIndexChangeRequestWorker(element, direction, table_id) {

    var tableIdSelector = '#' + table_id;

    //get product id from button clicked
    var productCollectionItemId = element.data('id');

    //get product status from rb
    const data = {
        productCollectionItemId: productCollectionItemId,
        displayIndexReorderDirection: direction
    };

    //set a data property on the table so that it can be picked up upon reload and a class applied to the pertinent row to provide a visual indicator of change
    $(tableIdSelector).data('last-index-changed', productCollectionItemId);

    const result = await manageDisplayIndexChangeRequestService(data);

    reloadProductBundleCollectionDatatable(table_id);
}

async function deleteProductCollectionItem(element, table_id) {

    //get product id from button clicked
    var productCollectionItemId = element.data('id');

    const data = {
        productCollectionItemId: productCollectionItemId
    };

    const result = await deleteProductCollectionItemService(data);

    reloadProductBundleCollectionDatatable(table_id);
}


async function setProductCollectionItemAsDefault(element, table_id) {

    //get product id from button clicked
    var productCollectionItemId = element.data('id');

    var collection_wrapper = element.closest('.variant-collection-wrapper');

    var variantEntityId = collection_wrapper.data('variant-entity-id');


    const data = {
        productCollectionItemId: productCollectionItemId,
        productVariantLinkedItemId: variantEntityId
    };

    const result = await setProductCollectionItemAsDefaultService(data);

    reloadProductBundleCollectionDatatable(table_id);
}


//API CALLS
async function manageDisplayIndexChangeRequestService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productbundlecollection/changeproductcollectionitemdisplayindex', data);

    return response.data;
}

async function deleteProductCollectionItemService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productbundlecollection/deleteproductcollectionitem', data);

    return response.data;
}

async function setProductCollectionItemAsDefaultService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productbundlecollection/setproductcollectionitemasdefault', data);

    return response.data;
}